import { render, staticRenderFns } from "./pt-copy-button.vue?vue&type=template&id=7e3d0500&"
import script from "./pt-copy-button.vue?vue&type=script&lang=js&"
export * from "./pt-copy-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports